import { render, staticRenderFns } from "./CRUDTable.vue?vue&type=template&id=2a4733fb"
import script from "./CRUDTable.vue?vue&type=script&lang=js"
export * from "./CRUDTable.vue?vue&type=script&lang=js"
import style0 from "./CRUDTable.vue?vue&type=style&index=0&id=2a4733fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports